import { BehaviorSubject } from 'rxjs'

import { getStateIsNight } from './lib/storage'

const subject = new BehaviorSubject(getStateIsNight())

export default subject
